import React, { Component } from 'react';
import './User.scss';
import withRouterAndRedux from 'src/hoc/withRouterAndRedux';
class UserLayout extends Component {
    render() {
        return (
            <div className='lesson-layout'>
                <main className='main'>{this.props.children}</main>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentLessonLayout, courseMenuOpen, showCourseMenu, loggedIn } = state;
    return {
        currentLessonLayout,
        courseMenuOpen,
        showCourseMenu,
        loggedIn,
    };
};

export default withRouterAndRedux(UserLayout, mapStateToProps, null);
